module.exports = __webpack_public_path__ + "static/media/archdesk.22b7597b.png";